// import '@gjensidige/core-fonts';

import React from 'react';
import { FaroErrorBoundary } from '@grafana/faro-react';
import { Expandable, Flex, Text, Title } from '@gjensidige/builders-components';
import { DateRange, Phone } from '@gjensidige/builders-icons';

import { MyPagesFeaturesCallMe } from './feature';
import { WorkingHours } from './feature/types';
import { EnonicDataType } from './feature/types';
import { LogoComponent } from './feature/lib/LogoComponent';
import { MyPagesFeaturesCallMeLater } from './feature/lib/MyPagesFeaturesCallMeLater';

interface AppProps {
  configs: EnonicDataType;
}

export function App({ configs }: AppProps) {
  const hide_widget = configs?.hide_widget?.split(',') || [];
  const expanded_widgets = configs?.expanded_widgets?.split(',') || [];
  // Function to check if a widget is expanded
  const isWidgetExpanded = (widget: string) =>
    expanded_widgets.includes(widget);
  //Function to check if a widget is hidden
  const isWidgetHidden = (widget: string) => hide_widget.includes(widget);

  return (
    <FaroErrorBoundary>
      {!!configs?.logo && <LogoComponent logo={configs.logo} />}
      <Flex
        center
        justify="center"
        direction="column"
        className="call-me-wrapper"
      >
        <Title as="h2" size="5">
          {configs.main_header || `Vill du prata med en rådgivare?`}
        </Title>
        {!isWidgetHidden('call-now') && (
          <Expandable
            variant="white-white"
            className="call-me-expandable"
            defaultOpen={isWidgetExpanded('call-now') || false}
          >
            <Expandable.Title>
              <Phone className="header-icon" />
              {configs.call_me_header || 'Ring nu'}
            </Expandable.Title>
            <Expandable.Content>
              <MyPagesFeaturesCallMe configs={configs} />
            </Expandable.Content>
          </Expandable>
        )}
        {!isWidgetHidden('call-later') && (
          <Expandable
            variant="white-white"
            className="call-me-expandable"
            defaultOpen={isWidgetExpanded('call-later') || false}
          >
            <Expandable.Title>
              <DateRange className="header-icon" />
              {configs.call_me_later_header || 'Bli uppringd senare'}
            </Expandable.Title>
            <Expandable.Content>
              <MyPagesFeaturesCallMeLater isScheduledCall configs={configs} />
            </Expandable.Content>
          </Expandable>
        )}
      </Flex>
    </FaroErrorBoundary>
  );
}

export default App;
